import { render, staticRenderFns } from "./addDImodel.vue?vue&type=template&id=3a2d492b&scoped=true"
import script from "./addDImodel.vue?vue&type=script&lang=js"
export * from "./addDImodel.vue?vue&type=script&lang=js"
import style0 from "./addDImodel.vue?vue&type=style&index=0&id=3a2d492b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2d492b",
  null
  
)

export default component.exports